import { useT } from '@/lib/i18n';
import { useEffect, useState } from 'react';

const STORE_KEY = 'pf-privacy-ack';

/**
 * One-shot privacy notice per CLAUDE.md §13. Bottom-of-page banner shown
 * until dismissed; never reappears. The "Got it" button writes the
 * acknowledgement to localStorage.
 */
export function PrivacyBanner() {
  const { t } = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof localStorage === 'undefined') return;
    if (localStorage.getItem(STORE_KEY) === '1') return;
    setShow(true);
  }, []);

  if (!show) return null;

  return (
    <output
      className="fixed bottom-0 left-0 right-0 z-40 bg-ink/95 text-paper border-t-2 border-ink"
      data-testid="privacy-banner"
    >
      <div className="max-w-4xl mx-auto px-4 py-3 flex flex-col md:flex-row items-start md:items-center gap-3 font-hand text-[14px]">
        <div className="flex-1">
          <span className="font-gloock text-[16px] mr-2">🔒 {t('privacy.title')}</span>
          <span>{t('privacy.body')}</span>
        </div>
        <button
          type="button"
          onClick={() => {
            localStorage.setItem(STORE_KEY, '1');
            setShow(false);
          }}
          className="shrink-0 px-4 py-1 bg-accent-yellow text-ink border-2 border-paper rounded-control font-gloock text-[14px] shadow-ink-sm hover:translate-y-[-1px] transition-transform"
          data-testid="privacy-dismiss"
        >
          {t('privacy.dismiss')}
        </button>
      </div>
    </output>
  );
}
